import { FETCH_INSTANCE_FULFILLED } from './actions';

import type { SafeScarfInstance } from '@/types/safeScarf';

interface InstanceActionType {
  type: string;
  payload?: unknown;
}

const initialState: SafeScarfInstance = { data: {} };

export const instanceReducer = (
  state: SafeScarfInstance = initialState,
  action: InstanceActionType
): SafeScarfInstance => {
  if (action.type === FETCH_INSTANCE_FULFILLED) {
    return {
      ...state,
      data: action.payload as Record<string, unknown>,
    };
  }

  return state;
};
